import { Card, CardAction, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/shadcn/card'
import { Separator } from '@/components/shadcn/separator'

interface Props {
  title: string
  description?: React.ReactNode
  /** Rendered top right in the header, e.g. a select or a key figure */
  headerAction?: React.ReactNode
  chart: React.ReactNode
  controls?: React.ReactNode
}

export function ChartCard({ title, description, headerAction, chart, controls }: Props) {
  return (
    <Card className="flex flex-col h-120">
      <CardHeader>
        <CardTitle className="text-foreground">{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
        {headerAction && <CardAction>{headerAction}</CardAction>}
      </CardHeader>
      <CardContent className="flex-1 flex flex-col gap-4">
        <div className="flex-1">{chart}</div>
        {controls && (
          <>
            <Separator />
            {controls}
          </>
        )}
      </CardContent>
    </Card>
  )
}
